import styled from 'styled-components';

import { preventTextSelection } from '../../styles/shared.style';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 787px;
  height: 65px;
  margin: 20px 0 16px 0;
  padding: 0 2px 0 0;

  &#carousel-dates {
    width: 100%;
  }
`;

export const ContainerItems = styled.div`
  display: flex;
  align-items: flex-end;
  width: 93%;
  height: 68px;
  gap: 12px;
  overflow-x: scroll;
  overflow-y: visible;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  cursor: grab;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 90px;
    height: 90%;
    z-index: 999999;
    background: linear-gradient(to left, ${({ theme : { colors } }) => colors.surface.base}, rgba(255,255,255,0));
  }
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 90px;
    height: 90%;
    z-index: 999999;
    background: linear-gradient(to right, ${({ theme : { colors } }) => colors.surface.base}, rgba(255,255,255,0));
  }
`;

export const ArrowLeft = styled.div<{$quantityItems: number, $currentPosition: number}>`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 24px;
    height: 24px;

    left: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 9999999;

    box-shadow: 0px 0px 5px -1px rgba(0,0,0,0.39);
    ${preventTextSelection()}
    & img {
      opacity: ${({ $quantityItems }) => $quantityItems < 5 ? 0.3 : 1};
    }

    &:hover {
        cursor: pointer;
        cursor: ${({ $quantityItems }) => $quantityItems < 5 ? 'not-allowed' : 'pointer'};
    }
`;

export const ArrowRight = styled(ArrowLeft)`
    left: auto;
    right: 0;
`;

export const Item = styled.div<{ $isLarge: boolean, $selected: boolean, $disabled: boolean }>`
  box-sizing: content-box;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: visible;
  height: 60px;
  width: 100%;
  min-width: ${({ $isLarge }) => $isLarge ? '185px' : '125px'};
  max-width: 154px;
  gap: 4px;
  border-radius: 8px;
  background-color: ${({ theme : { colors }, $disabled }) => $disabled ? colors.surface.high : colors.surface.base};
  transition: background-color 0.3s, opacity 0.3s;
  border: 1px solid
  ${({ $selected, theme : { colors } }) =>
    $selected ? colors.accent.primary : colors.border};
  transition: border-color 0.5s;
  ${preventTextSelection()}

  & h1 {
    margin: 0;
    font-family: "MADE TOMMY";
    font-size: 15px;
    font-weight: 700;
    line-height: 19.6px;
    text-align: ${({ $isLarge }) => $isLarge ? 'center' : 'left'};
    color: ${({ $selected, theme : { colors }, $disabled }) =>
    $disabled ? (
      colors.button.text.disabled
    ) : $selected ? (
      colors.accent.primary
    ) : colors.text.primary
};
    transition: color 0.3s;
  }

  & span {
    font-family: Inter;
    font-size: 11px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: left;
    color: ${({ $selected, theme : { colors }, $disabled }) =>
    $disabled ? (
      colors.button.text.disabled
    ) : $selected ? (
      colors.accent.secondary
    ) : colors.text.secondary
};
  }
`;

export const SingleDayDate = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 65px;
  width: 100%;
  gap: 4px;
  border-radius: 8px;
  ${preventTextSelection()}
`;

export const WrapperSingleDate = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (max-width: 1200px) {
    flex-direction: column;
    margin-bottom: 20px;
  }
`;

export const TileDay = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  text-align: left;
`;

export const Subtitle = styled.span`
  font-family: "MADE TOMMY";
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
`;
